import PageScrolledController from './controllers/page-scrolled-controller'

export default function initPageScrolledController () {
  return new PageScrolledController({
    scrolledClass: 'page--scrolled',
    tolerance: 20
  })
}
